Pixlee.module('WidgetsApp.Item', function(Item, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    Item.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            this.album = options.album;
            this.photoModel = options.photoModel;
            this.durations = {
                'vine': 6.617687,
                'instagram_video': 15
            };
        },
        changePhoto: function(wrapper, id) {
            var _this = this;
            var photo = this.getCurrent(id);
            if (this.photoDesc) this.photoDesc.destroy();
            if (gon.isMobileDevice) this.photoDesc = new Item.MobileLightBoxDesc({
                model: photo,
                wrapperDiv: wrapper,
                album: this.album
            });
            else this.photoDesc = new Item.LightBoxDesc({
                model: photo,
                wrapperDiv: wrapper,
                album: this.album
            });
            this.photoDesc.on({
                'share:pinterest': _this.handlePinterestShare,
                'share:twitter': _this.handleTwitterShare,
                'share:facebook': _this.handleFacebookShare,
                'share:tumblr': _this.handleTumblrShare,
                'action:clicked': _this.actionClicked,
                'vote:clicked': _this.voteClicked
            });
            this.photoDesc.render();
        },
        isVideo: function(container, id, selectedArray, selectedIndex) {
            var video = this.getCurrent(id);
            this.selectedArray = selectedArray;
            this.selectedIndex = selectedIndex;
            if (this.video) this.video.destroy();
            this.video = new Item.VideoView({
                model: video,
                container: container,
                album: this.album
            });
            this.video.render();
            var source = video.get('source');
            this.checkVideo(source);
        },
        getCurrent: function(id) {
            if (this.album) {
                return this.album.find(function(model) {
                    return model.get('album_photo_id') == id;
                });
            } else if (this.photoModel) {
                return this.photoModel;
            }

        },
        checkVideo: function(source) {
            var _this = this;
            // if (gon.videoPlayer) {
            // 	gon.videoPlayer.dispose();
            // }
            var opts = {
                flash: {
                    swf: '/flash/video-js.swf'
                },
                techOrder: ['html5', 'flash']
            };
            if ($('#example_video_1').length > 0) {
                videojs('example_video_1', opts, function() {
                    gon.videoPlayer = this;
                    _this.playerReady(source);
                });
            }
        },
        playerReady: function(source) {
            var _this = this;
            //gon.videoPlayer.cache_.duration = this.durations[source];
            gon.videoPlayer.on('play', function() {
                if (_this.selectedArray && _this.selectedArray.length === 1) {
                    $('.vjs-big-play-button').hide();
                } else {
                    $('#fancybox-left, #fancybox-right, .vjs-big-play-button').hide();
                }

            });
            gon.videoPlayer.on('pause', function() {
                if (_this.selectedArray && _this.selectedArray.length === 1) {
                    $('.vjs-big-play-button').show();
                } else {
                    if (_this.selectedIndex === 0) {
                        $('#fancybox-right').show();
                    } else if (_this.selectedIndex === _this.selectedArray.length - 1) {
                        $('#fancybox-left').show();
                    } else if ((_this.selectedIndex < _this.selectedArray.length - 1) && _this.selectedIndex > 0) {
                        $('#fancybox-left, #fancybox-right').show();
                    }
                    $('.vjs-big-play-button').show();
                }
            });
            gon.videoPlayer.on('ended', function() {
                if (_this.selectedArray && _this.selectedArray.length === 1) {
                    $('.vjs-big-play-button').show();
                } else {
                    if (_this.selectedIndex === 0) {
                        $('#fancybox-right').show();
                    } else if (_this.selectedIndex === _this.selectedArray.length - 1) {
                        $('#fancybox-left').show();
                    } else if ((_this.selectedIndex < _this.selectedArray.length - 1) && _this.selectedIndex > 0) {
                        $('#fancybox-left, #fancybox-right').show();
                    }
                    $('.vjs-big-play-button').show();
                }
            });
        },
        handlePinterestShare: function(model) {
            App.commands.execute('open:share:pinterest', model);
        },
        handleTwitterShare: function(model) {
            App.commands.execute('open:share:twitter', model);
        },
        handleFacebookShare: function(model) {
            App.commands.execute('open:share:facebook', model);
        },
        handleTumblrShare: function(model) {
            App.commands.execute('open:share:tumblr', model);
        },
        voteClicked: function(view, model) {
            App.commands.execute('exec:vote:clicked', view, model);
        },
        actionClicked: function(model, action_link_url, action_text) {
            App.commands.execute('log:action:clicked', model, action_link_url, action_text);
        }
    });

});